import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RandomAccessClass;
function RandomAccess() {
  if (RandomAccessClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'RandomAccess');
    RandomAccessClass = $;
  }
  return RandomAccessClass;
}
//region block: exports
export {
  RandomAccess as RandomAccess1jbw8sdogqb8x,
};
//endregion

//# sourceMappingURL=RandomAccess.mjs.map
